import { ConversationStatus, InputMaybe } from 'generated-graphql/types';
import { CandidateStatus } from 'services/candidate/types';

export type AutomationTask = {
  id: string;
  requirementConditions: Array<RequirementCondition>;
  action: AutomationAction;
  candidateBatchId: string;
  createdAt: string;
  updatedAt: string;
  organizationId: string;
  parentAutomationTaskId?: string | null;
};

export type RequirementCondition = {
  type: RequirementConditionType;
  operator?: RequirementConditionOperator | null;
  candidateStatus?: CandidateStatus | null;
  conversationStatus?: ConversationStatus | null;
  scoreScaled?: number | null;
  documentTypes?: Array<string> | null;
};

export enum RequirementConditionType {
  CANDIDATE_REQUIREMENTS_MET_CONDITION = 'CANDIDATE_REQUIREMENTS_MET_CONDITION',
  CANDIDATE_SCORE_CONDITION = 'CANDIDATE_SCORE_CONDITION',
  CANDIDATE_STATUS_CONDITION = 'CANDIDATE_STATUS_CONDITION',
  CONVERSATION_STATUS_CONDITION = 'CONVERSATION_STATUS_CONDITION',
  CONVERSATION_DOCUMENT_UPLOAD_CONDITION = 'CONVERSATION_DOCUMENT_UPLOAD_CONDITION',
  ANY_CANDIDATE_STATUS_CONDITION = 'ANY_CANDIDATE_STATUS_CONDITION'
}

export enum RequirementConditionOperator {
  IS_TRUE = 'IS_TRUE',
  IS_FALSE = 'IS_FALSE',
  EQUALS = 'EQUALS',
  GREATER_THAN = 'GREATER_THAN',
  LOWER_THAN = 'LOWER_THAN',
  EQUAL_TO_OR_GREATER_THAN = 'EQUAL_TO_OR_GREATER_THAN',
  EQUAL_TO_OR_LOWER_THAN = 'EQUAL_TO_OR_LOWER_THAN'
}

export type AutomationAction = {
  __typename: 'AutomationAction';
  type: AutomationActionType;
  campaignId?: string | null;
  candidateStatus?: CandidateStatus | null;
  atsRejectedReasonId?: string | null;
  atsInterviewStageId?: string | null;
  komboRejectionReasonId?: string | null;
  komboStageId?: string | null;
  includePersonalisation?: boolean | null;
  includeJobBoardLink?: boolean | null;
  jobBoardLink?: string | null;
  automationTaskEmailTemplateId?: string | null;
  recipientEmailAddress?: string | null;
};

export enum AutomationActionType {
  SEND_CAMPAIGN = 'SEND_CAMPAIGN',
  UPDATE_CANDIDATE_STATUS = 'UPDATE_CANDIDATE_STATUS',
  UPDATE_ATS = 'UPDATE_ATS',
  SEND_EMAIL = 'SEND_EMAIL',
  CREATE_CANDIDATE_NOTE_FROM_CONVERSATION = 'CREATE_CANDIDATE_NOTE_FROM_CONVERSATION',
  SEND_DOCUMENT_VIA_EMAIL = 'SEND_DOCUMENT_VIA_EMAIL',
  SEND_JOB_RECOMMENDATION_EMAIL = 'SEND_JOB_RECOMMENDATION_EMAIL'
}

export type RequirementConditionInput = {
  type: RequirementConditionType;
  operator?: RequirementConditionOperator | null;
  candidateStatus?: CandidateStatus | null;
  conversationStatus?: ConversationStatus | null;
  scoreScaled?: number | null;
  documentTypes?: InputMaybe<InputMaybe<string>[]>;
};

export type AutomationActionInput = {
  type: AutomationActionType;
  campaignId?: string | null;
  candidateStatus?: CandidateStatus | null;
  atsRejectedReasonId?: string | null;
  atsInterviewStageId?: string | null;
  komboRejectionReasonId?: string | null;
  komboStageId?: string | null;
  includePersonalisation?: boolean | null;
  includeJobBoardLink?: boolean | null;
  jobBoardLink?: string | null;
  automationTaskEmailTemplateId?: string | null;
};

export type CreateAutomationTaskInput = {
  id?: string | null;
  requirementConditions: Array<RequirementConditionInput>;
  action: AutomationActionInput;
  candidateBatchId?: string;
  campaignId?: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  organizationId: string;
  includePersonalisation?: boolean | null;
  includeJobBoardLink?: boolean | null;
  jobBoardLink?: string | null;
  automationTaskEmailTemplateId?: string | null;
};

export type UpdateAutomationTaskInput = {
  id: string;
  requirementConditions?: Array<RequirementConditionInput> | null;
  action?: AutomationActionInput | null;
  candidateBatchId?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  includePersonalisation?: boolean | null;
  includeJobBoardLink?: boolean | null;
  jobBoardLink?: string | null;
  automationTaskEmailTemplateId?: string | null;
};

export type DeleteAutomationTaskInput = {
  id: string;
};

export type AutomationTasksSavedInput = {
  candidateBatchId: string;
};

/**
 * @deprecated use generated types
 */
export type AutomationTaskInput = {
  requirementConditions: Array<RequirementConditionInput>;
  action: AutomationActionInput;
};

export type AutomationTaskEmailTemplate = {
  id: string;
  organizationId: string;
  defaultEmailTemplate: string;
  emailTemplateWithPersonalisation: string;
  emailTemplateWithJobBoardLink: string;
  emailTemplateWithPersonalisationAndJobBoardLink: string;
  jobRecommendationsEmailTemplate?: string | null;
  jobRecommendationsEmailTemplateWithJobBoardLink?: string | null;
  customEmailTemplate?: string | null;
  createdAt: string;
  updatedAt: string;
};

/**
 * @deprecated use automationFormItem from modules/analyse/types/AutomationForItem
 */
export type AutomationFormItem = {
  id?: string;
  requirementConditions: {
    type: RequirementConditionType;
    operator?: RequirementConditionOperator | null;
    candidateStatus?: CandidateStatus | null;
    scoreScaled?: number | null;
    campaignId?: string | null;
  }[];
  action: {
    type?: AutomationActionType;
    candidateStatus?: CandidateStatus | null;
    campaignId?: string | null;
    atsRejectedReasonId?: string | null;
    atsInterviewStageId?: string | null;
    automationTaskEmailTemplateId?: string | null;
    includePersonalisation?: boolean | null;
    includeJobBoardLink?: boolean | null;
    jobBoardLink?: string | null;
  };
};
